import React from 'react';
import FadeIn from './FadeIn';

const flow = [
  { time: "1:00 PM", title: "Getting Ready", desc: "Private preparation in the Bridal Suite" },
  { time: "4:30 PM", title: "The Ceremony", desc: "Vows exchanged in the olive courtyard" },
  { time: "5:30 PM", title: "Cocktail Hour", desc: "Sunset portraits and terrace drinks" },
  { time: "7:00 PM", title: "Dinner Service", desc: "Chef-driven catering in the Historic Ballroom" },
  { time: "8:30 PM", title: "Dancing", desc: "Reception celebrations under vaulted ceilings" },
  { time: "11:00 PM", title: "Sendoff", desc: "A cinematic exit to remember" }
];

const WeddingFlow = () => (
  <section className="pt-32 pb-16 bg-brand-vintage px-6">
    <div className="max-w-6xl mx-auto">
      <div className="text-center mb-20">
        <FadeIn>
          <span className="text-brand-bronze uppercase tracking-[0.3em] text-[10px] font-bold mb-4 block">The Journey</span>
          <h2 className="font-serif text-3xl md:text-4xl text-brand-charcoal font-light">What Your Day Can Feel Like</h2>
          <div className="w-16 h-[1px] bg-brand-stone mx-auto mt-8" />
        </FadeIn>
      </div>

      <div className="relative">
        <div className="hidden md:block absolute top-1/2 left-0 right-0 h-[1px] bg-brand-stone/40 -translate-y-1/2 z-0" />
        
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-10 md:gap-4 relative z-10">
          {flow.map((step, idx) => (
            <FadeIn key={idx} delay={idx * 0.1} className="flex flex-col items-center text-center group">
              <div className="text-[9px] uppercase tracking-[0.2em] text-brand-bronze mb-4 font-bold opacity-70">
                {step.time}
              </div>
              <div className="w-3 h-3 rounded-full bg-brand-vintage border border-brand-olive mb-6 shadow-[0_0_0_4px_rgba(252,250,246,1)] group-hover:bg-brand-olive transition-colors duration-500" />
              <h3 className="font-serif text-lg text-brand-charcoal mb-2 font-light">{step.title}</h3>
              <p className="font-sans text-xs text-brand-charcoal/60 font-light tracking-wide px-2 leading-relaxed">
                {step.desc}
              </p>
            </FadeIn>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default WeddingFlow;